import {isCopilot} from '@github-ui/assignees/copilot-user'
import {
  type RepoPullRequest,
  RepoPullRequestAuthorIdentity,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_pulls_dashboard'

import {normalizeReviewerSlug} from '../overview/reviewers/copilot-reviewer'

export type StackAuthor = {
  login: string
  label: string
  isAgent: boolean
  isCopilot: boolean
  isBot: boolean
  count: number
}

export function getStackAuthors(pullRequests: ReadonlyArray<Pick<RepoPullRequest, 'author'>>): StackAuthor[] {
  const authors = new Map<string, StackAuthor>()
  const baseAuthor = pullRequests.at(-1)?.author?.displayLogin

  for (const {author} of [...pullRequests].reverse()) {
    if (!author?.displayLogin) continue
    const login = author.displayLogin
    const existing = authors.get(login)
    if (existing) {
      existing.count += 1
    } else {
      const copilot = isCopilot(normalizeReviewerSlug(login))
      authors.set(login, {
        login,
        label: author.displayName || login,
        isAgent: author.identity === RepoPullRequestAuthorIdentity.AI || copilot,
        isCopilot: copilot,
        isBot: author.identity === RepoPullRequestAuthorIdentity.BOT,
        count: 1,
      })
    }
  }

  return [...authors.values()].sort(
    (a, b) => Number(b.login === baseAuthor) - Number(a.login === baseAuthor) || b.count - a.count,
  )
}
